import React, { PureComponent } from 'react';
import { ModalFooter, ModalHeader, ModalBody } from '@atlaskit/modal-dialog';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import extendModalDialogWithAnalytics from '../common/modal-dialog-with-analytics';
import ViewTracker from '../../common/analytics/view-tracker';
import { type OwnProps, type StateProps, type Props } from './types';
import { ContextualAnalyticsData, fireUIAnalytics, MODAL } from '@atlassian/analytics-bridge';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FullWidthContainer = styled.div({
	width: '100%',
});

class ConnectSpaceDialog extends PureComponent<Props> {
	static defaultProps = {
		ModalDialog: null,
	};
	ModalDialogImpl: any;

	constructor(props: Props) {
		super(props);
		const { ModalDialog } = props;
		this.ModalDialogImpl = extendModalDialogWithAnalytics(
			'connectSpaceModal',
			ModalDialog as React.ComponentClass<any>,
		);
	}

	onDismissed = (_: any, analyticsEvent: any) => {
		const { onCancel } = this.props;
		onCancel && onCancel();
		fireUIAnalytics(analyticsEvent, 'dismissedModalDialog');
	};

	render() {
		const { Header, Content, Footer, isOpen } = this.props;

		// eslint-disable-next-line no-undef
		if (__SERVER__) {
			return null;
		}
		return (
			isOpen && (
				<form>
					<this.ModalDialogImpl width={'small'} shouldCloseOnEscapePress onClose={this.onDismissed}>
						<ModalHeader>
							<FullWidthContainer>
								<Header />
							</FullWidthContainer>
						</ModalHeader>
						<ModalBody>
							<Content />
						</ModalBody>
						<ModalFooter>
							<FullWidthContainer>
								<Footer />
							</FullWidthContainer>
						</ModalFooter>
						<ViewTracker />
					</this.ModalDialogImpl>
				</form>
			)
		);
	}
}

export default (props: OwnProps & StateProps) => (
	<ContextualAnalyticsData sourceName="connectSpace" sourceType={MODAL}>
		<ConnectSpaceDialog {...props} />
	</ContextualAnalyticsData>
);
